import { Box, Typography } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { StructuredContentRenderer } from '../../../../../StructuredContentRenderer';
import { CheckIcon } from './CheckIcon';

export const ProsItems = ({ pro }: { pro?: StructuredContentDocument | string }) => {
  return (
    <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
      <CheckIcon />
      {typeof pro === 'string' ? (
        <Typography>{pro}</Typography>
      ) : (
        <StructuredContentRenderer doc={pro} />
      )}
    </Box>
  );
};
